export function decimalToHexString(number) {
    if (number < 0) {
        number = 0xFFFFFFFF + number + 1;
    }

    return '#' + number.toString(16).toUpperCase();
}

export function hexToDecimal(hex) {
    return parseInt(hex.replace('#', ''), 16);
}
